import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import "./index.scss";

const Save = ({ savePrice }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <div className="GP-C-SB-T-S">
      <p className="GP-C-SB-T-S__text">
        {`${t("Save")} $${savePrice.toLocaleString(t("language code"))}+`}
      </p>
    </div>
  );
};

Save.propTypes = {
  savePrice: PropTypes.number,
};

export default Save;
